import Observer from '../lib/Observer';
import Device from '../lib/Device';
import { $, $$, isDOM } from '../lib/Util';

const observer = new Observer();
const device = new Device();

let config = {};

/**
 * Baseオブジェクト
 */
export default class Base {
    /**
     * constructor
     *
     * @param {object} elements
     * @param {object} options
     */
    constructor(elements = {}, options = {}) {
        this.cache(elements);
        this.initialize(options);
    }

    /**
     * 設定を設定
     *
     * @param {object} conf initの設定
     */
    static set config(conf) {
        config = conf;
    }

    /**
     * 設定を取得
     *
     * @return {object}
     */
    get config() {
        return config;
    }

    /**
     * Observerを取得
     *
     * @return {Observer}
     */
    get observer() {
        return observer;
    }

    /**
     * Deviceを取得
     *
     * @return {Device}
     */
    get device() {
        return device;
    }

    /**
     * 共通のGAラベル文字列
     *
     * @return {string}
     */
    get commonGALabel() {
        return `0000：${this.config.title}：${this.config.genre}`;
    }

    /**
     * initialize
     *
     * @abstract
     */
    initialize() {
    }

    /**
     * 要素をキャッシュする
     *
     * @param {object} elements 要素
     */
    cache(elements) {
        const globalContexts = ['el', 'template'];

        Object.keys(elements).forEach((property) => {
            const selector = elements[property];
            const context = globalContexts.includes(property) ? document : this.$el;
            const $element = isDOM(selector) ? selector : $(selector, context);

            if (!$element) {
                throw Error(`Element not found: [${property}], [${selector}]`);
            }

            this[`$${property}`] = $element;

            if (selector !== $element) {
                this[property] = selector;
            }
        });
    }

    /**
     * querySelector
     *
     * @param {string} selector セレクタ
     * @param {HTMLElement} context コンテキスト
     *
     * @return {Element|null}
     */
    $(selector) {
        return $(selector, this.$el);
    }

    /**
     * querySelectorAll
     *
     * @param {string} selector セレクタ
     * @param {HTMLElement} context コンテキスト
     *
     * @return {NodeList[]}
     */
    $$(selector) {
        return $$(selector, this.$el);
    }

    /**
     * 端末が横長が正面かどうか
     */
    isLandscapePrimaryDevice() {
        const orientationType = (window.screen.orientation || {}).type;
        return orientationType === 'landscape-primary'
            || orientationType === 'portrait-secondary';
    }
}
